export const villas = [
  {
    id: "v1",
    title: "Villa Helios",
    location: "Mykonos",
    price: "From €2,800 / night",
    guests: 10,
    bedrooms: 5,
    bathrooms: 5,
    cover: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=1600&q=90",
    gallery: [
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=1600&q=90",
      "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=1600&q=90",
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=1600&q=90",
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1600&q=90",
    ],
    tag: "Villa",
    desc: "A breathtaking Cycladic villa perched above the Aegean with an infinity pool, private chef service, and sunset views that define the Greek dream.",
    features: ["Infinity Pool", "Private Chef", "Sea View", "A/C", "Daily Housekeeping", "Airport Transfer"],
    airbnbUrl: "#contact",
  },
  {
    id: "v2",
    title: "Villa Selene",
    location: "Santorini",
    price: "From €3,500 / night",
    guests: 8,
    bedrooms: 4,
    bathrooms: 4,
    cover: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1600&q=90",
    gallery: [
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1600&q=90",
      "https://images.unsplash.com/photo-1601918774516-ab2de5a78f09?w=1600&q=90",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1600&q=90",
      "https://images.unsplash.com/photo-1615880484746-a134be9a6ecf?w=1600&q=90",
    ],
    tag: "Villa",
    desc: "Carved into the caldera cliffs of Santorini, Villa Selene offers iconic sunset views, a private plunge pool, and interiors of white marble and Cycladic stone.",
    features: ["Caldera View", "Plunge Pool", "Concierge", "Wine Cellar", "Sea Access", "A/C"],
    airbnbUrl: "#contact",
  },
];

export const athensListings = [
  {
    id: "a1",
    title: "Acropolis View Studio",
    location: "Acropolis, Athens",
    price: "From €180 / night",
    guests: 2,
    bedrooms: 1,
    bathrooms: 1,
    cover: process.env.PUBLIC_URL + "/images/airbnb1_living.jpg",
    gallery: [process.env.PUBLIC_URL + "/images/airbnb1_living.jpg", process.env.PUBLIC_URL + "/images/airbnb1_bedroom.jpg", process.env.PUBLIC_URL + "/images/airbnb1_dining.jpg", process.env.PUBLIC_URL + "/images/airbnb1_balcony.jpg"],
    tag: "Studio",
    desc: "Wake up to the Parthenon. This designer studio on the slopes of the Acropolis hill features a private rooftop terrace with an unmatched view of Athens' greatest monument.",
    features: ["Acropolis View", "Rooftop Terrace", "Designer Interior", "Nespresso", "Netflix", "A/C"],
    airbnbUrl: "#contact",
  },
  {
    id: "a3",
    title: "Koukaki Studio",
    location: "Koukaki, Athens",
    price: "From €150 / night",
    guests: 2,
    bedrooms: 1,
    bathrooms: 1,
    cover: process.env.PUBLIC_URL + "/images/koukaki_living.jpg",
    gallery: [process.env.PUBLIC_URL + "/images/koukaki_living.jpg", process.env.PUBLIC_URL + "/images/koukaki_bedroom.jpg", process.env.PUBLIC_URL + "/images/koukaki_dining.jpg", process.env.PUBLIC_URL + "/images/koukaki_kitchen.jpg", process.env.PUBLIC_URL + "/images/koukaki_workspace.jpg", process.env.PUBLIC_URL + "/images/koukaki_bathroom.jpg", process.env.PUBLIC_URL + "/images/koukaki_shower.jpg"],
    tag: "Studio",
    desc: "A beautifully designed studio in Koukaki, steps from the Acropolis Museum. Clean Scandinavian-inspired interiors with oak accents, a fully equipped kitchen, and everything you need for the perfect Athens stay.",
    features: ["Acropolis Museum Nearby", "Fully Equipped Kitchen", "Work Desk", "Smart TV", "A/C", "WiFi"],
    airbnbUrl: "#contact",
  },
  {
    id: "a2",
    title: "Plaka Heritage Apartment",
    location: "Plaka, Athens",
    price: "From €220 / night",
    guests: 4,
    bedrooms: 2,
    bathrooms: 1,
    cover: process.env.PUBLIC_URL + "/images/airbnb2_living.jpg",
    gallery: [process.env.PUBLIC_URL + "/images/airbnb2_living.jpg", process.env.PUBLIC_URL + "/images/airbnb2_bedroom.jpg", process.env.PUBLIC_URL + "/images/airbnb2_balcony.jpg", process.env.PUBLIC_URL + "/images/airbnb2_bath.jpg"],
    tag: "Apartment",
    desc: "A beautifully restored two-bedroom apartment in Athens' oldest neighbourhood. Original stone walls, oak floors, and a private balcony over the winding Plaka streets.",
    features: ["Balcony", "Restored Interior", "City Views", "Fully Equipped Kitchen", "A/C", "WiFi"],
    airbnbUrl: "#contact",
  },
];

export const islandListings = [
  {
    id: "i1",
    title: "Mykonos Boho Suite",
    location: "Mykonos Town",
    price: "From €350 / night",
    guests: 4,
    bedrooms: 2,
    bathrooms: 2,
    cover: process.env.PUBLIC_URL + "/images/airbnb2_balcony.jpg",
    gallery: [process.env.PUBLIC_URL + "/images/airbnb2_balcony.jpg", process.env.PUBLIC_URL + "/images/airbnb2_living.jpg", process.env.PUBLIC_URL + "/images/airbnb2_bedroom.jpg"],
    tag: "Suite",
    desc: "A whitewashed Cycladic suite steps from Little Venice. Private terrace with Aegean views, designer interiors, and close proximity to Mykonos' legendary nightlife.",
    features: ["Sea View Terrace", "Cycladic Design", "Walking Distance to Town", "A/C", "Daily Cleaning"],
    airbnbUrl: "#contact",
  },
  {
    id: "i2",
    title: "Santorini Caldera Retreat",
    location: "Oia, Santorini",
    price: "From €480 / night",
    guests: 2,
    bedrooms: 1,
    bathrooms: 1,
    cover: process.env.PUBLIC_URL + "/images/airbnb1_balcony.jpg",
    gallery: [process.env.PUBLIC_URL + "/images/airbnb1_balcony.jpg", process.env.PUBLIC_URL + "/images/airbnb1_living.jpg", process.env.PUBLIC_URL + "/images/airbnb1_bedroom.jpg"],
    tag: "Suite",
    desc: "The world's most iconic sunset — yours every evening from this cave-carved caldera retreat in Oia. Plunge pool, champagne welcome, and pure Santorini magic.",
    features: ["Caldera View", "Plunge Pool", "Champagne Welcome", "Concierge", "A/C"],
    airbnbUrl: "#contact",
  },
  {
    id: "i3",
    title: "Paros Seafront Villa",
    location: "Naoussa, Paros",
    price: "From €600 / night",
    guests: 8,
    bedrooms: 4,
    bathrooms: 3,
    cover: process.env.PUBLIC_URL + "/images/airbnb2_bath.jpg",
    gallery: [process.env.PUBLIC_URL + "/images/airbnb2_bath.jpg", process.env.PUBLIC_URL + "/images/airbnb2_bedroom.jpg", process.env.PUBLIC_URL + "/images/airbnb1_dining.jpg"],
    tag: "Villa",
    desc: "A converted seafront captain's house in charming Naoussa — direct sea access, private pool, and the authentic Cycladic atmosphere that Paros does best.",
    features: ["Sea Access", "Private Pool", "Boat Mooring", "BBQ Terrace", "Daily Housekeeping"],
    airbnbUrl: "#contact",
  },
];

export const yachts = [
  {
    id: "y1",
    name: "S/Y UPTIME",
    model: "Beneteau Oceanis 62",
    type: "Sailing Yacht",
    length: "19.16 m",
    guests: "8 daily",
    cabins: "3 + skipper",
    speed: "10 knots",
    cover: process.env.PUBLIC_URL + "/images/yacht-uptime.jpg",
    gallery: [process.env.PUBLIC_URL + "/images/yacht-uptime.jpg"],
    desc: "An elegant blue-water sailing yacht offering the purest Aegean experience. Her wide beam, Terrace on the Sea, and spacious cockpit make her perfect for relaxed island hopping or extended passages.",
    features: ["Terrace on the Sea", "Cockpit Galley", "A/C 48,000 BTU", "Seabob & Paddleboard", "Full Audio System"],
    charter: ["Day Cruise", "Sunset Cruise", "Island Hopping", "Weekly Charter"],
    pricing: [
      { type: "Day Cruise", price: "On Request" },
      { type: "Island Hopping", price: "On Request" },
      { type: "Weekly", price: "On Request" },
    ],
    departure: "Agios Kosmas Marina, Athens",
  },
  {
    id: "y2",
    name: "M/Y FROG",
    model: "Riva Vertigo 63",
    type: "Motor Yacht",
    length: "19.57 m",
    guests: "10 daily · 6 overnight",
    cabins: "3 (Master, VIP, Twin)",
    speed: "35 knots",
    cover: process.env.PUBLIC_URL + "/images/yacht-frog.jpg",
    gallery: [process.env.PUBLIC_URL + "/images/yacht-frog.jpg"],
    desc: "The only Riva Vertigo in Greece — a masterpiece of Italian craftsmanship. With 2 × 1,360 HP MAN engines she reaches 35 knots, delivering the ultimate fast-cruise experience on the Aegean.",
    features: ["Italian Craftsmanship", "2 × 1,360 HP MAN", "3 Ensuite Bathrooms", "SUP & Water Toys", "Premium Sound System"],
    charter: ["Half Day", "Full Day", "Multi-Day", "Island Hopping"],
    pricing: [
      { type: "Half Day (4h)", price: "On Request" },
      { type: "Full Day", price: "On Request" },
      { type: "Multi-Day", price: "On Request" },
    ],
    departure: "Agios Kosmas Marina, Athens",
  },
  {
    id: "y3",
    name: "M/Y TRANQUILLIUS",
    model: "Riva Rivale 52",
    type: "Motor Yacht",
    length: "15.61 m",
    guests: "8 daily · 4 overnight",
    cabins: "2 (Master, Twin)",
    speed: "28 knots",
    cover: process.env.PUBLIC_URL + "/images/yacht-tranquillius.jpg",
    gallery: [process.env.PUBLIC_URL + "/images/yacht-tranquillius.jpg"],
    desc: "The Riva Rivale 52 — Italian design at its most seductive. Intimate, fast, and undeniably beautiful, Tranquillius is perfect for couples or small groups seeking an unforgettable Aegean day.",
    features: ["Italian Design", "2 × 930 HP MAN", "2 Ensuite Bathrooms", "Snorkeling Equipment", "Bose Sound System"],
    charter: ["Half Day", "Full Day", "Multi-Day", "Island Hopping"],
    pricing: [
      { type: "Half Day (4h)", price: "On Request" },
      { type: "Full Day", price: "On Request" },
      { type: "Multi-Day", price: "On Request" },
    ],
    departure: "Agios Kosmas Marina, Athens",
  },
];
